import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import Helmet from "react-helmet"
import { Status } from '@bitcine/cs-theme'
import Subscription from "./components/subscription"
import PaymentMethods from "./components/payment_methods"
import UpcomingInvoice from './components/upcoming_invoice'
import Invoices from "./components/invoices"
import { can, MANAGE_CREDIT_CARDS, VIEW_INVOICES } from "@src/helpers/authorization"

const Billing = ({ updating, showSubscription, showUpcomingInvoice, showPaymentMethods, showInvoices }) => (
  <div data-test-id='billing'>
    <Helmet title='CineSend | Billing'/>
    <Status pending={updating}>
      {showSubscription && <Subscription/>}
      {showPaymentMethods && <PaymentMethods/>}
      {showUpcomingInvoice && <UpcomingInvoice/>}
      {showInvoices && <Invoices/>}
    </Status>
  </div>
)

Billing.propTypes = {
  showSubscription: PropTypes.bool,
  showUpcomingInvoice: PropTypes.bool,
  showPaymentMethods: PropTypes.bool,
  showInvoices: PropTypes.bool,
  updating: PropTypes.bool
}

const mapStateToProps = state => ({
  updating: state.settings.billing.status === 'UPDATING',
  showUpcomingInvoice: can(state.user, [VIEW_INVOICES]) && Boolean(state.user.subscription.stripe_plan_id
    || (state.user.organization && !state.user.organization.is_enterprise)),
  showPaymentMethods: can(state.user, [MANAGE_CREDIT_CARDS]),
  showInvoices: can(state.user, [VIEW_INVOICES]),
  showSubscription: !state.user.organization || (state.user.organization && !state.user.organization.is_enterprise)
    || (state.user.organization.plan && state.user.organization.plan.can_access_files !== false)
})

export default connect(
  mapStateToProps,
)(Billing)
